import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'
import { connect } from 'react-redux'
import { checkLasted } from './actions/checkLasted'
// Wrapper page with navbar

import {MuiThemeProvider} from 'material-ui/styles'
import AppShell from './template/AppShell'

// Page Containers
import Home from './containers/Home/Home'
import Details from './containers/Details/Details'
import Seemore from './containers/Seemore/Seemore'
import Contact from './containers/Contact/Contact'
import About from './containers/About/About'
import Bookmark from './containers/Bookmark/BookmarkContainer'
import Map from './containers/Map/Map'

const NoMatch = ({ location }) => (
  <div>
    <h3>Not fount for <code>{location.pathname}</code></h3>
  </div>
)

const changeIsOnline = ({ isOnline }) => ({ type: 'APP_STATE', isOnline })

const WithOffline = (WrapperComponent) => {
  class Offline extends Component {
    constructor(props) {
      super(props);
      this.handleOnLine = this.handleOnLine.bind(this)
      this.handleOffline = this.handleOffline.bind(this)
    }
    componentDidMount() {
      this.props.changeIsOnline({ isOnline: navigator.onLine })
      this.props.checkLasted()
      window.addEventListener('online', this.handleOnLine);
      window.addEventListener('offline', this.handleOffline);
    }
    handleOnLine() {
      // console.log('handleOnLine onLine', navigator.onLine)
      this.props.changeIsOnline({ isOnline: true })
    }
    handleOffline() {
      // console.log('handleOffline onLine', navigator.onLine)
      this.props.changeIsOnline({ isOnline: false })
    }
    render() {
      return <WrapperComponent {...this.props} />
    }
  }
  return connect(undefined, { changeIsOnline, checkLasted })(Offline)
}

const Routers = ({ onLine }) => (
  <MuiThemeProvider>
    <Router>
        <Switch>
          <Route exact path="/" component={Home}/>
          <Route path="/home" component={Home}/>
          <Route path="/Seemore/:types" component={Seemore}/>
          <Route path="/contact" component={Contact}/>
          <Route path="/details/:types/:id" component={Details}/>
          <Route path="/about" component={About}/>
          <Route path="/bookmark" component={Bookmark}/>
          <Route path="/map" component={Map}/>
          <Route component={NoMatch}/>
        </Switch>
    </Router>
  </MuiThemeProvider>
)
export default WithOffline(Routers)


// WEBPACK FOOTER //
// ./src/routers.js